module.exports = __webpack_public_path__ + "img/win2.d2a0b650.png";